import { Box, Tooltip } from '@mui/material';
import React, { useMemo } from 'react';
import LoadingButton from '../utils/common/LoadingButton.jsx';

// Constantes pour les types de destinataires
const RECIPIENT_TYPES = {
  CONTACT: 'CONTACT',
  SERVICE_PROVIDER: 'SERVICEPROVIDER',
};

const MessageTypeSelector = ({
  ticket,
  isDraftLoading,
  isLoadingSave,
  isLoadingSend,
  setRecipientType,
  handleShowMessageBox,
}) => {
  const isLoading = useMemo(
    () => isDraftLoading || isLoadingSave || isLoadingSend,
    [isDraftLoading, isLoadingSave, isLoadingSend]
  );

  const ticketValidation = useMemo(() => {
    const isTicketAssigned = ticket?.assignedTo != null;
    const hasThreadIdForRabbitMQ = !(
      ticket?.contactChannelType === 'RABBITMQ' && !ticket.threadId
    );
    const hasOrder = Boolean(ticket?.order);

    // Calculer les messages directement au lieu de fonctions
    const contactTooltipMessage = !isTicketAssigned
      ? 'Ce ticket doit être assigné pour pouvoir y rédiger un nouveau message'
      : !hasThreadIdForRabbitMQ
        ? 'Pas de threadId sur ce ticket, merci de vous rapprocher de votre administrateur (Team IT Pandora)'
        : '';

    const serviceProviderTooltipMessage = !isTicketAssigned
      ? 'Ce ticket doit être assigné pour pouvoir y rédiger un nouveau message'
      : '';

    return {
      isTicketAssigned,
      hasThreadIdForRabbitMQ,
      hasOrder,
      contactTooltipMessage,
      serviceProviderTooltipMessage,
    };
  }, [ticket]);

  // Handlers extraits pour plus de lisibilité
  const handleContactClick = () => {
    setRecipientType(RECIPIENT_TYPES.CONTACT);
    handleShowMessageBox(RECIPIENT_TYPES.CONTACT);
  };

  const handleServiceProviderClick = () => {
    setRecipientType(RECIPIENT_TYPES.SERVICE_PROVIDER);
    handleShowMessageBox(RECIPIENT_TYPES.SERVICE_PROVIDER);
  };

  // Configuration des boutons pour éviter la duplication
  const buttonConfigs = [
    {
      key: 'contact',
      onClick: handleContactClick,
      disabled: false, // Toujours activé, la validation se fait via tooltip
      tooltipMessage: ticketValidation.contactTooltipMessage,
      label: ticket?.contactDraft
        ? 'Reprendre brouillon (contact)'
        : 'Ecrire au contact',
    },
    {
      key: 'serviceProvider',
      onClick: handleServiceProviderClick,
      disabled: !ticketValidation.hasOrder,
      tooltipMessage: ticketValidation.serviceProviderTooltipMessage,
      label: ticket?.serviceProviderDraft
        ? 'Reprendre brouillon (prestataire)'
        : 'Ecrire au prestataire',
    },
  ];

  return (
    <Box
      sx={{
        height: '30vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        gap: 5,
      }}
    >
      {buttonConfigs.map((config) => (
        <Tooltip
          key={config.key}
          placement="right"
          title={config.tooltipMessage}
        >
          <span>
            <LoadingButton
              isLoading={isLoading}
              variant="contained"
              onClick={config.onClick}
              disabled={config.disabled}
              sx={{ marginRight: 2 }}
              size="small"
            >
              {config.label}
            </LoadingButton>
          </span>
        </Tooltip>
      ))}
    </Box>
  );
};

export default MessageTypeSelector;
